import { render, staticRenderFns } from "./TestV.vue?vue&type=template&id=1840b498&"
import script from "./TestV.vue?vue&type=script&lang=js&"
export * from "./TestV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports